// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1cvdS","left":"StickyBox_left__1TTBj","right":"StickyBox_right__2xcNR"};